import { ColDef } from 'ag-grid-community';
import { buildColDefFromColumnDefinition } from '@instinet-analytics/semantic-ui-components';
import {
    ColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';

import { IndigoAppContextType } from 'app/AppContext';

export type StrategyParametersColumn = 'name' | 'val';

export const strategyParamsColumnDefinitions: ColumnDefinitionsDictionary<StrategyParametersColumn> =
    {
        name: {
            field: 'name',
            name: 'Name',
            textAlign: 'left',
            minWidth: 100,
            valueType: ValueType.STRING,
        },
        val: {
            field: 'val',
            name: 'Value',
            textAlign: 'left',
            minWidth: 100,
            valueType: ValueType.STRING,
        },
    };

export const strategyParamColDefs: (
    context: IndigoAppContextType
) => ColDef[] = (context) => [
    buildColDefFromColumnDefinition(
        context,
        strategyParamsColumnDefinitions.name.name,
        strategyParamsColumnDefinitions.name
    ),
    buildColDefFromColumnDefinition(
        context,
        strategyParamsColumnDefinitions.val.name,
        strategyParamsColumnDefinitions.val
    ),
];
